export default __webpack_public_path__ + "static/lady1-65d5b0c53ed06330c491193544b7fa8d.jpg";